<div class="filters container">
  <mat-form-field>
    <mat-label>Entity</mat-label>
    <input matInput (keyup)="applyFiltersOnEnterKey($event)" [formControl]="filterForm.controls.name" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Difficulty</mat-label>
    <mat-select
      [formControl]="filterForm.controls.tax_return_difficulty_level_id">
      <mat-option>&mdash;</mat-option>
      @for (
        difficulty of documentRequirementsService.taxReturnDifficultyLevels$
        | async
        ; track
        difficulty) {
        <mat-option
          [value]="difficulty.id"
          >{{ difficulty.difficulty_level }}</mat-option
          >
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Sort</mat-label>
      <mat-select [formControl]="filterForm.controls.sort">
        <mat-option>&mdash;</mat-option>
        <mat-option value="name">Name</mat-option>
        <mat-option value="difficulty">Difficulty</mat-option>
        <mat-option value="updated">Last Updated</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox [formControl]="filterForm.controls.include_all"
      >Show permanently excluded entities</mat-checkbox
      >
      <button mat-raised-button color="primary" (click)="applyFilters()">
        Apply Filters
      </button>
      <button mat-raised-button (click)="clearFilters()">Clear Filters</button>
    </div>
    <div class="controls container">
      <span>
        <button mat-raised-button (click)="refreshData()">Refresh Data</button>
        <button mat-raised-button (click)="initializeTracker()" color="primary">
          Initialize Tracker
        </button>
        <button mat-raised-button (click)="addDocuments()" color="primary">
          Add Documents
        </button>
      </span>
      <mat-paginator
    [pageSize]="
      $safeNavigationMigration((documentRequirementsService.docTypeRequirements$ | async)?.paginatorInfo
        ?.perPage)
    "
        [hidePageSize]="true"
        [showFirstLastButtons]="true"
    [pageIndex]="
      ((documentRequirementsService.docTypeRequirements$ | async)?.paginatorInfo
        ?.currentPage ??
        1) -
      1
    "
        (page)="getPage($event.pageIndex + 1)"
    [length]="
      (documentRequirementsService.docTypeRequirements$ | async)?.paginatorInfo
        ?.total ?? 0
    "></mat-paginator>
    </div>
    <div class="container">
      <table mat-table [dataSource]="items$">
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell>Name</th>
          <td *matCellDef="let item" mat-cell>
            <span class="entity">{{ item.owned_entity_name ?? "\u2014" }}</span>
            <a class="related_entity" target="_blank" [href]="item.related_url">{{
              item.related_name
            }}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="closed_date">
          <th *matHeaderCellDef mat-header-cell>Closed Date</th>
          <td *matCellDef="let item" mat-cell>
            {{
            item.closed_date ? (item.closed_date | date: "MM/dd/yyyy") : "\u2014"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="disposed_date">
          <th *matHeaderCellDef mat-header-cell>Disposed Date</th>
          <td *matCellDef="let item" mat-cell>
            {{
            item.disposed_date
            ? (item.disposed_date | date: "MM/dd/yyyy")
            : "\u2014"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="difficulty_level">
          <th *matHeaderCellDef mat-header-cell>Difficulty</th>
          <td *matCellDef="let item" mat-cell>
            <select
              [disabled]="!(item.return_permissions | permission: '_edit')"
              [(ngModel)]="item.entity.tax_return_difficulty_level_id"
              (change)="updateDifficultyLevel($event, item)">
              <option [value]="null">&mdash;</option>
              @for (
                difficultyLevel of documentRequirementsService.taxReturnDifficultyLevels$
                | async
                ; track
                difficultyLevel) {
                <option
                  [value]="difficultyLevel.id">
                  {{ difficultyLevel.difficulty_level }}
                </option>
              }
            </select>
          </td>
        </ng-container>
        <ng-container matColumnDef="audit_requirement">
          <th *matHeaderCellDef mat-header-cell>Audit Include/Exclude</th>
          <td *matCellDef="let item" mat-cell>
            <select
              [disabled]="!(item.audit_permissions | permission: '_edit')"
              [(ngModel)]="item.audit_requirement"
          (change)="
            updateRequirementFlag('Audit', item, item.audit_requirement)
          ">
              <option [value]="true">Include</option>
              <option [value]="false">Exclude</option>
              <option [value]="null">Exclude Permanently</option>
            </select>
          </td>
        </ng-container>
        <ng-container matColumnDef="audit_dates">
          <th *matHeaderCellDef mat-header-cell>Audit Due Dates</th>
          <td *matCellDef="let item" mat-cell>
            <span class="due_date">
              <label>Draft</label>
              <input
                [disabled]="!(item.audit_permissions | permission: '_edit')"
                type="date"
                [class]="{ empty: !item.audit_draft_requirement?.due_date }"
                [value]="$safeNavigationMigration(item.audit_draft_requirement?.due_date)"
                (change)="dueDateChange.next({type:'Audit', subType:'Draft', item, event:$event})" />
            </span>
            <span class="due_date">
              <label>Final</label>
              <input
                [disabled]="!(item.audit_permissions | permission: '_edit')"
                [class]="{ empty: !item.audit_final_requirement?.due_date }"
                type="date"
                [value]="$safeNavigationMigration(item.audit_final_requirement?.due_date)"
                (change)="dueDateChange.next({type:'Audit', subType:'Final', item, event:$event})" />
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="return_requirement">
          <th *matHeaderCellDef mat-header-cell>Return Include/Exclude</th>
          <td *matCellDef="let item" mat-cell>
            <select
              [disabled]="!(item.return_permissions | permission: '_edit')"
              [(ngModel)]="item.return_requirement"
          (change)="
            updateRequirementFlag('Tax Return', item, item.return_requirement)
          ">
              <option [value]="true">Include</option>
              <option [value]="false">Exclude</option>
              <option [value]="null">Exclude Permanently</option>
            </select>
          </td>
        </ng-container>
        <ng-container matColumnDef="return_dates">
          <th *matHeaderCellDef mat-header-cell>Return Due Dates</th>
          <td *matCellDef="let item" mat-cell>
            <span class="due_date">
              <label>Draft</label>
              <input
                [disabled]="!(item.return_permissions | permission: '_edit')"
                [class]="{ empty: !item.return_draft_requirement?.due_date }"
                type="date"
                [value]="$safeNavigationMigration(item.return_draft_requirement?.due_date)"
                (change)="dueDateChange.next({type:'Tax Return', subType:'Draft', item, event:$event})" />
            </span>
            <span class="due_date">
              <label>Final</label>
              <input
                type="date"
                [disabled]="!(item.return_permissions | permission: '_edit')"
                [class]="{ empty: !item.return_final_requirement?.due_date }"
                [value]="$safeNavigationMigration(item.return_final_requirement?.due_date)"
                (change)="dueDateChange.next({type:'Tax Return', subType:'Final', item, event:$event})" />
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="last_updated">
          <th *matHeaderCellDef mat-header-cell>Last Upd.</th>
          <td *matCellDef="let item" mat-cell>
            @if (item.user_name === null) {
              <span class="user_name">System</span>
            }
            @if (item.user_name !== null) {
              <a
                [href]="item.user_url"
                class="user_name"
                >{{ item.user_name }}</a
                >
              }
              <span class="updated">{{ item.modified | date: "MM/dd/yyyy" }}</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
        </table>
      </div>
